import { httpRequest } from "../../http"

export class CommandCloseEngagement {
  async run(engagementId: number) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/close/`
    const response = await httpRequest<any>(url, {
      method: "POST",
    })
    return response
  }
}
